import * as S from "./styles";

type Props = {
  icon: React.ReactNode;
  title: string;
  variant?: "light" | "dark";
};

export function IconedHeader({ icon, title, variant = "light" }: Props) {
  return (
    <S.Wrapper>
      <S.IconContainer variant={variant}>{icon}</S.IconContainer>

      <h3>{title}</h3>
    </S.Wrapper>
  );
}
